import { helper } from '@ember/component/helper';

/**
 * Converte un valore in numero gestendo stringhe con virgola
 */
const toNumber = val => {
  if (typeof val === 'number') return val;
  if (typeof val === 'string') {
    const normalized = val.trim();
    // Number('') e Number('   ') danno 0: azzererebbero il prodotto. Scarta.
    return normalized === '' ? NaN : Number(normalized.replace(',', '.'));
  }
  return NaN;
};

/**
 * Calcola il prodotto di numeri
 */
var numberMult = helper(function numberMult(numbers) {
  if (!Array.isArray(numbers) || numbers.length === 0) return 0;
  const validNumbers = numbers.map(toNumber).filter(n => !isNaN(n));
  if (validNumbers.length === 0) return 0;
  return validNumbers.reduce((acc, val) => acc * val);
});

export { numberMult as default };
//# sourceMappingURL=number-mult.js.map
